import type { DepartmentAssignmentHistoryFilterOption } from './typeFilterOptions';

export function getAssignmentHistoryErrorFilterOptions (labelsOptions: Record<number, string>): DepartmentAssignmentHistoryFilterOption[] {
  return [
    { id: -1, label: 'Все', value: null },
    ...Object.entries(labelsOptions).map(
      ([value, label]) => ({
        id: Number(value),
        label,
        value: Number(value)
      })
    )
  ];
} 
